import { render, staticRenderFns } from "./Type4Block.vue?vue&type=template&id=42f7433f&scoped=true&"
import script from "./Type4Block.vue?vue&type=script&lang=js&"
export * from "./Type4Block.vue?vue&type=script&lang=js&"
import style0 from "./Type4Block.vue?vue&type=style&index=0&id=42f7433f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f7433f",
  null
  
)

export default component.exports